import { isSSR } from '@k2/core/util'
import { useOAuth } from 'vue-oidc'
import type { NavigationGuardWithThis } from 'vue-router'
import { useTeamStore } from '../store'

// FR-A16's second trigger. A guard, not a hook `auth` calls: `team` imports `auth`, so the reverse would be circular.
export const acceptInvitationsGuard: NavigationGuardWithThis<undefined> = async () => {
  if (isSSR) return true

  const { isAuthorized } = useOAuth()
  if (isAuthorized.value) await useTeamStore().acceptOnce()

  return true
}
